import React, { useState } from 'react';
import Modal from '../../common/modal';

const MobileMenu = () => {
  const [ opened, setOpened ] = useState(false);
  const handleOpenModal = () => {
    setOpened(true);
  };
  const handleCloseModal = () => {
    setOpened(false);
  };
  return (
    <>
      <div className="hamburger-item" onClick={ handleOpenModal } />
      {
        opened &&
        <Modal
          className="hamburger-modal"
          classNameDialog="hamburger-modal-dialog"
          handleClose={ handleCloseModal }
          modal
        >
          <ul className="with-lines">
            <li><span>Mobile</span></li>
            <li><span>Home Internet</span></li>
            <li><span className="continue">Shop</span></li>
            <li><span className="continue">Deals</span></li>
            <li><span>Business</span></li>
          </ul>
          <ul>
            <li><span>1-833-VERIZON</span></li>
            <li><span>Contact us</span></li>
            <li><span>Support</span></li>
            <li><span>Stores</span></li>
            <li><span>Coverage map</span></li>
            <li><span>Español</span></li>
          </ul>
        </Modal>
      }
    </>
  );
};

export default MobileMenu;
